import React, { ReactElement, useEffect, useState } from 'react';
import StoreList from '../../../src/components/storeList';
import { extractUniqStoresFromFlyers } from '../../../src/helpers/store';
import Layout from '../../../src/components/layout';
import { Flyer } from '../../../src/definitions/FlyerDefinitions';
import { DataJSON } from '../../../src/definitions/BackflippDefinitions';
import { getBreadcrumbsData } from '../../../src/helpers/breadcrumbs';
import Breadcrumbs from '../../../src/components/breadcrumbs';
import { useRouter } from 'next/router';
import { LinkData } from '../../../src/helpers/common';
import useLocationDetect from '../../../src/hooks/useLocationDetect';
import { extractCityFromLocation } from '../../../src/helpers/location';
import Footer from '../../../src/components/footer';
import { getCommonServerSideProps } from '../../../src/helpers/serverSideProps';

interface StoresRouteProps {
  data: DataJSON;
  cities: LinkData[];
  merchants: LinkData[];
}

export default function StoresRoute({ data }: StoresRouteProps): JSX.Element {
  const router = useRouter();
  const [stores, setStores] = useState([]);
  const location = useLocationDetect(router);
  const city = extractCityFromLocation(location.location);

  useEffect(() => {
    if (data) {
      const flyers = data.flyers.map((flyer) => new Flyer(flyer));
      const stores = extractUniqStoresFromFlyers(flyers);
      setStores(stores);
    }
  }, [data]);

  return (
    <>
      <Breadcrumbs breadcrumbs={getBreadcrumbsData(router)} />
      <StoreList stores={stores} city={city} />
      <Footer />
    </>
  );
}

StoresRoute.getLayout = function getLayout(page: ReactElement) {
  return <Layout params={{ ...page.props.children[1].props }}>{page}</Layout>;
};

export async function getServerSideProps({ query, locale, res }) {
  return getCommonServerSideProps({ query, locale, res });
}
